import React from 'react';
import styled from 'styled-components';
import { fontMontserrat } from 'ui/typography';
import { BREAKPOINTS } from '../../../utils';
import { Link } from 'react-router-dom';

export const ButtonBack = ({ title = '', link = '' }) => {
  return (
    <Link to={link}>
      <StyledButton>
        {title}
      </StyledButton>
    </Link>
  );
};

const StyledButton = styled.button`
    height: 50px;
    background: transparent;
    font-weight: 600;
    padding: 0;
    font-size: 18px;
    line-height: 30px;
    color: #106eb7;
    border: none;
    border-radius: 4px;
    transition: 0.1s;
    cursor: pointer;

    ${fontMontserrat}
    :hover {
        color: #5fa1d5;
    }
   
    @media (max-width: ${BREAKPOINTS.lg}px) {
        height: 36px;
        font-size: 16px;
        line-height: 21px;
    }
    @media (max-width: ${BREAKPOINTS.sm}px) {
        height: 28px;
        font-size: 14px;
        line-height: 15px;
        letter-spacing: unset;
    }
`;
